<template>
    <section class="administration-userinterface">
        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="phone" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="interfaceMunicipalityCode">Kommunekoder til adresseopslag</label>
                </div>
                <div class="cell auto">
                    <input type="text" id="interfaceMunicipalityCode" v-model="municipalityCodeFilter" />
                </div>
            </div>
        </div>

        <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="enquiry" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="interfaceMunicipalityCode">Henvendelse</label>
                </div>
                <div class="cell auto">
                    <div class="grid-x">
                        <div class="large-5 cell">
                            <span>Beskrivelse skal som standard vises på entreprenøropgave og i bestillingsmail</span>
                        </div>
                        <div class="auto cell">
                            <switches v-model="showRequestDescriptionOnRequisition" theme="custom" type-bold="false" color="blue" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="hide" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label>Tænd/sluk felter i henvendelser</label>
                </div>
                <div class="cell auto select-supply">
                    <div class="grid-x">
                        <div class="select-supply-container" v-for="businessAreaType in businessAreaTypeList" v-bind:key="businessAreaType.code" @click="selectBusinessAreaType(businessAreaType)">
                            <div class="button-radio-round" :id="businessAreaType.systemName.toLowerCase()" :class="{'selected-supply': checkSelectedBusinessArea(businessAreaType.systemName)}">
                                <icon class="small-svg fill-white" :name="businessAreaType.systemName.toLowerCase()" />
                            </div>
                            <span>{{ businessAreaType.description }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form">
            <div class="grid-x">
                <div style="width: 40px;"></div>
                <div class="cell small-3"></div>
                <div class="cell auto">
                    <div class="grid-x" style="margin-bottom: 10px;">
                        <div class="large-5 cell" style="min-width: 165px;">
                            <span style="margin-left: 9px;"><b>Anmelder - Kontakttype</b></span>
                        </div>
                        <div class="auto cell">
                            <div v-if="selectedBusinessAreaSystemName">
                                <switches v-model="enabledClientType" theme="custom" type-bold="false" color="blue" />
                            </div>
                        </div>
                    </div>

                    <div class="grid-x" style="margin-bottom: 10px;">
                        <div class="large-5 cell" style="min-width: 165px;">
                            <span style="margin-left: 9px;"><b>Problem - Ejendomstype</b></span>
                        </div>
                        <div class="auto cell">
                            <div v-if="selectedBusinessAreaSystemName">
                                <switches v-model="enabledEstateType" theme="custom" type-bold="false" color="blue" />
                            </div>
                        </div>
                    </div>

                    <div class="grid-x" style="margin-bottom: 10px;">
                        <div class="large-5 cell" style="min-width: 165px;">
                            <span style="margin-left: 9px;"><b>Problem - Vejrtype</b></span>
                        </div>
                        <div class="auto cell">
                            <div v-if="selectedBusinessAreaSystemName">
                                <switches v-model="enabledWeatherType" theme="custom" type-bold="false" color="blue" />
                            </div>
                        </div>
                    </div>

                    <div class="grid-x" style="margin-bottom: 10px;">
                        <div class="large-5 cell" style="min-width: 165px;">
                            <span style="margin-left: 9px;"><b>Problem - Klage</b></span>
                        </div>
                        <div class="auto cell">
                            <div v-if="selectedBusinessAreaSystemName">
                                <switches v-model="enabledIsComplaint" theme="custom" type-bold="false" color="blue" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="phone" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label>SMS notifikation</label>
                </div>
                <div class="cell auto">
                    <div class="grid-x">
                        <div class="large-5 cell">
                            <span>Send til anmelder i henvendelse</span>
                        </div>
                        <div class="auto cell">
                            <switches v-model="enabledSmsRequest" theme="custom" type-bold="false" color="blue" />
                        </div>
                    </div>
                    <div class="grid-x">
                        <div class="large-5 cell">
                            <span>Send ved rekvirering af entreprenøropgave</span>
                        </div>
                        <div class="auto cell">
                            <switches v-model="enabledSmsRequisition" theme="custom" type-bold="false" color="blue" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="phone" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label>Tipløsning</label>
                </div>
                <div class="cell auto">
                    <div class="grid-x">
                        <div class="large-6 cell">
                            <p style="margin-bottom: 0.5em; padding-top: 0;"><strong>Obligatoriske felter?</strong></p>
                        </div>
                    </div>
                    <div class="grid-x">
                        <div class="large-5 cell">
                            <span>Navn</span>
                        </div>
                        <div class="auto cell">
                            <switches v-model="tipNameRequired" theme="custom" type-bold="false" color="blue" />
                        </div>
                    </div>
                    <div class="grid-x">
                        <div class="large-5 cell">
                            <span>Telefonnummer og e-mail</span>
                        </div>
                        <div class="auto cell">
                            <select v-model="tipPhoneEmailRequired">
                                <option value="0">Ingen</option>
                                <option value="2">Kun telefonnummer</option>
                                <option value="1">Kun e-mail</option>
                                <option value="3">Én af delene</option>
                                <option value="4">Begge dele</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="automated-process" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="interfaceMunicipalityCode">Automatisk afslutning</label>
                </div>
                <div class="cell auto">
                    <div class="grid-x">
                        <div class="large-5 cell">
                            <span>Afslut henvendelse(r) ved afslut opgave</span>
                        </div>
                        <div class="auto cell">
                            <switches v-model="enabledwhenCloseTaskCloseRequest" theme="custom" type-bold="false" color="blue" />
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <hr />

        <div class="form">
            <div class="grid-x">
                <div style="width: 40px;"></div>
                <div class="cell small-3"></div>
                <div class="cell auto">
                    <button class="button button-form-primary" @click="save()">{{ buttonLabel }}</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Switches from 'vue-switches'
import axios from '../../../../store/api.js'

export default {
    components: {
        Switches
    },
    data () {
        return {
            selectedListSystemName: null,
            enteredNewItem: null,
            buttonLabel: 'Gem',
            showRequestDescriptionOnRequisition: false,
            enabledClientType: true,
            enabledEstateType: true,
            enabledWeatherType: true,
            enabledIsComplaint: true,
            municipalityCodeFilter: null,
            enabledSmsRequest: false,
            enabledSmsRequisition: false,
            enabledwhenCloseTaskCloseRequest: false,

            tipNameRequired: false,
            tipPhoneEmailRequired: 0 // Email = 1; Phone = 2; Email or Phone = 3; Email and Phone = 4
        }
    },
    computed: {
        ...mapGetters({
            applicationSettingsDrive: 'getApplicationSettingsDrive',
            applicationList: 'getApplicationList',
            application: 'getApplication',
            selectedBusinessAreaSystemName: 'getSelectedBusinessAreaSystemName',
            businessAreaTypeList: 'getSysBusinessAreaTypeList'
        })
    },
    methods: {
        ...mapActions({
            setApplicationSettingsDrive: 'setApplicationSettingsDrive',
            setAllCodeLists: 'setAllCodeLists',
            setSelectedBusinessAreaSystemName: 'setSelectedBusinessAreaSystemName',
            setApplication: 'setApplication',
            updateDriveSettings: 'updateDriveSettings'
        }),
        selectBusinessAreaType (businessAreaType) {
            if (businessAreaType) {
                this.setSelectedBusinessAreaSystemName(businessAreaType.systemName)
                this.setFieldsEnabled()
            }
        },
        checkSelectedBusinessArea (businessAreaTypeSystemName) {
            if (this.selectedBusinessAreaSystemName === businessAreaTypeSystemName) {
                return true
            } else {
                return false
            }
        },
        setFieldsEnabled () {
            this.enabledWeatherType = true
            this.enabledClientType = true
            this.enabledEstateType = true
            this.enabledIsComplaint = true

            if (this.selectedBusinessAreaSystemName) {
                this.setApplicationSettingsDrive()

                if (this.applicationSettingsDrive) {
                    this.applicationSettingsDrive.forEach(element => {
                        if (element.name === 'show_fields') {
                            if (element.value) {
                                let showFields = element.value
                                showFields.forEach(s => {
                                    if (s.BusinessAreaSystemName === this.selectedBusinessAreaSystemName) {
                                        this.enabledWeatherType = s.RequestShowWeatherType
                                        this.enabledClientType = s.RequestShowClientType
                                        this.enabledEstateType = s.RequestShowEstateType
                                        this.enabledIsComplaint = s.RequestShowComplaint
                                    }
                                })
                            }
                        }
                    })
                }
            }
        },
        save () {
            this.buttonLabel = 'Gemmer...'
            new Promise((resolve, reject) => {
                let showFieldsSettingObject = {
                    'businessAreaSystemName': this.selectedBusinessAreaSystemName,
                    'requestShowWeatherType': this.enabledWeatherType,
                    'requestShowClientType': this.enabledClientType,
                    'requestShowEstateType': this.enabledEstateType,
                    'requestShowComplaint': this.enabledIsComplaint
                }
                let codeList = this.municipalityCodeFilter.replace(/\s/g, '')
                codeList = '[' + codeList + ']'

                let driveSettings = {
                    'municipalityCodeList': JSON.parse(codeList),
                    'smsRequest': this.enabledSmsRequest,
                    'smsRequisition': this.enabledSmsRequisition,
                    'whenCloseTaskCloseRequest': this.enabledwhenCloseTaskCloseRequest,
                    'showFields': showFieldsSettingObject,
                    'defaultShowRequestDescriptionOnRequisition': this.showRequestDescriptionOnRequisition
                }
                resolve(this.updateDriveSettings(driveSettings))

                let publicSettings = {
                    'nameFieldIsmandatory': this.tipNameRequired,
                    'contactTypeMandatory': this.tipPhoneEmailRequired
                }
                axios.post('/PublicRequest/SetRequestPublicSettings', publicSettings)
                    .then((response) => {
                        console.log('response', response)
                    }, error => {
                        console.error('error', error)
                    })
            }).then(() => {
                this.buttonLabel = 'Gem'
            })
        }
    },
    created () {
        if (this.applicationList.filter(app => app.value.toLowerCase() === 'drive').length > 0) {
            new Promise((resolve, reject) => {
                resolve(this.setApplication(this.applicationList.filter(app => app.value.toLowerCase() === 'drive')[0].key))
            }).then(() => {
                this.setAllCodeLists()
                this.setApplicationSettingsDrive()
            })
        }

        if (this.applicationSettingsDrive) {
            let adrListFilter
            if (this.applicationSettingsDrive.find(i => i.name === 'address_list_filter' && i.category === 'address' && i.value)) {
                adrListFilter = this.applicationSettingsDrive.find(i => i.name === 'address_list_filter' && i.category === 'address').value
                this.municipalityCodeFilter = adrListFilter.join()
            }

            let useSmsRequest
            if (this.applicationSettingsDrive.find(i => i.name === 'sms_request' && i.category === 'email_sms' && i.value)) {
                useSmsRequest = this.applicationSettingsDrive.find(i => i.name === 'sms_request' && i.category === 'email_sms').value
                this.enabledSmsRequest = useSmsRequest === '1'
            }

            let useSmsRequisition
            if (this.applicationSettingsDrive.find(i => i.name === 'sms_requisition' && i.category === 'email_sms' && i.value)) {
                useSmsRequisition = this.applicationSettingsDrive.find(i => i.name === 'sms_requisition' && i.category === 'email_sms').value
                this.enabledSmsRequisition = useSmsRequisition === '1'
            }

            let useWhenCloseTaskCloseRequest
            if (this.applicationSettingsDrive.find(i => i.name === 'when_close_task_close_request' && i.category === 'admin_task' && i.value)) {
                useWhenCloseTaskCloseRequest = this.enabledwhenCloseTaskCloseRequest = this.applicationSettingsDrive.find(i => i.name === 'when_close_task_close_request' && i.category === 'admin_task').value
                this.enabledwhenCloseTaskCloseRequest = useWhenCloseTaskCloseRequest === '1'
            }

            let useShowRequestDescriptionOnRequisition
            if (this.applicationSettingsDrive.find(i => i.name === 'default_show_request_description_on_requisition' && i.category === 'admin_task' && i.value)) {
                useShowRequestDescriptionOnRequisition = this.showRequestDescriptionOnRequisition = this.applicationSettingsDrive.find(i => i.name === 'default_show_request_description_on_requisition' && i.category === 'admin_task').value
                this.showRequestDescriptionOnRequisition = useShowRequestDescriptionOnRequisition === '1'
            }
        }

        axios.post('/PublicRequest/GetApplicationSettings')
            .then((response) => {
                if (response && response.data) {
                    const nameSetting = response.data.find(setting => setting.name === 'name_mandatory')
                    const phoneEmailSetting = response.data.find(setting => setting.name === 'email_phone_mandatory')
                    const phoneEmailMapping = {
                        'Email': 1,
                        'Phone': 2,
                        'EmailOrPhone': 3,
                        'EmailAndPhone': 4
                    }

                    this.tipNameRequired = nameSetting ? nameSetting.value === '1' : false
                    this.tipPhoneEmailRequired = phoneEmailSetting ? phoneEmailMapping[phoneEmailSetting.value] : 0
                }
            }, error => {
                console.error('error', error)
            })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/drive/administration-userinterface.vue